/**
 * Formats a string to be used as an Akamai cache tag following the rules defined in the Akamai documentation.
 * https://techdocs.akamai.com/purge-cache/docs/assign-cache-tags#edge-cache-tag-header
 * This class also matches the functionality in Common.Code.Helpers.Dotnet > Cache.cs file
 * @param stringToBeTagged
 * @returns
 */

export const ToAkamaiCacheTag = (stringToBeTagged: string): string => {
  const charsToRemove = /[<>*@\\{}:,"=()?;[\]\s]/g;
  let formattedString = stringToBeTagged.replace(charsToRemove, '');
  const MAX_TAG_LENGTH = 128;
  // Trim the string to 128 characters if it's longer
  if (formattedString.length > MAX_TAG_LENGTH) {
    formattedString = formattedString.substring(0, MAX_TAG_LENGTH);
  }

  return formattedString.toLowerCase();
};

export const AKAMAI_CACHE_TAG_HEADER = 'Edge-Cache-Tag';
